import { motion, AnimatePresence } from "framer-motion";

export default function ConfirmDialog({ open, message, onConfirm, onCancel }) {
  return (
    <AnimatePresence>
      {open && (
        <motion.div
          className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
        >
          <motion.div
            className="bg-white rounded-xl p-6 w-full max-w-md shadow-lg"
            initial={{ scale: 0.8 }}
            animate={{ scale: 1 }}
            exit={{ scale: 0.8 }}
          >
            <p className="text-lg font-semibold text-secondary mb-6">
              {message}
            </p>

            <div className="flex justify-end gap-4">
              <button
                className="btn"
                onClick={onCancel}
              >
                Cancel
              </button>
              <button
                className="btn btn-primary"
                onClick={onConfirm}
              >
                Confirm
              </button>
            </div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
